// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".partners[data-v-6a405bf8]{display:flex;align-items:center;justify-content:center;background:url(/images/homePage/partners/background.png) no-repeat;background-size:cover;padding:70px 0 50px}.partners .partners-content[data-v-6a405bf8]{width:1200px;overflow:hidden}.partners .partners-content .all-imgs[data-v-6a405bf8]{padding-top:70px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
